import React from 'react';
import { Link } from 'react-router-dom';

class SchoolDetailsEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      school: this.props.school
    };

    this.makeDetailsPanel = this.makeDetailsPanel.bind(this);
    this.makeDetailsEditorPanel = this.makeDetailsEditorPanel.bind(this);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // getDerivedStateFromProps(props, state) {
  //   return {
  //     school: props.school
  //   };
  // }

  handleInputChange(e) {
    const prop = e.currentTarget.name;
    const val = e.currentTarget.value;

    this.setState((prevState) => {
      prevState.school[prop] = val;

      return prevState;
    });
  }

  handleSubmit() {
    this.props.onSubmit(this.state.school);
  }

  makeDetailsEditorPanel(school) {
    return (
      <div>
        <h2>Dettagli principali</h2>
        <p>
          <strong><i className="fa fa-lock" /> ID/ C.M.:</strong><br />
          <input className="form-control" name="id" value={this.state.school.id} disabled />
        </p>
        <p>
          <strong>Nome</strong><br />
          <input className="form-control" name="name" value={this.state.school.name} onChange={this.handleInputChange} />
        </p>
        <p>
          <strong>Indirizzo:</strong><br />
          <input className="form-control" name="address" value={this.state.school.address} onChange={this.handleInputChange} />
        </p>
        <p>
          <strong>CAP:</strong><br />
          <input className="form-control" name="postcode" value={this.state.school.postcode} onChange={this.handleInputChange} />
        </p>
        <p>
          <strong><i className="fa fa-lock" /> Citta:</strong><br />
          <input className="form-control" name="" value={this.state.school.city_name + (this.state.school.province_iso_code ? ' (' + this.state.school.province_iso_code + ')' : '')} disabled />
        </p>
        <hr />
        <p>
          <strong>Email:</strong><br />
          <input className="form-control" name="email" value={this.state.school.email} onChange={this.handleInputChange} />
        </p>
        <p>
          <strong>PEC:</strong><br />
          <input className="form-control" name="certified_email" value={this.state.school.certified_email} onChange={this.handleInputChange} />
        </p>
        <p>
          <strong>Sito web:</strong><br />
          <input className="form-control" name="website" value={this.state.school.website} onChange={this.handleInputChange} />
        </p>

        <h2>Info aggiuntive</h2>
        <p>
          <strong>Facebook:</strong><br />
          <input className="form-control" name="facebook_url" value={this.state.school.facebook_url} onChange={this.handleInputChange} />
        </p>
        <p>
          <strong>Twitter:</strong><br />
          <input className="form-control" name="twitter_url" value={this.state.school.twitter_url} onChange={this.handleInputChange} />

        </p>

        <h2>Metadati</h2>
        <p>
          <strong>Leggono email?:</strong><br />
          <select className="form-control" name="email_they_read" value={this.state.school.email_they_read} onChange={this.handleInputChange}>
            <option value="1">SI</option>
            <option value="0">NO</option>
          </select>
        </p>
        <p>
          <strong>Leggono PEC?:</strong><br />
          <select className="form-control" name="certified_email_they_read" value={this.state.school.certified_email_they_read} onChange={this.handleInputChange}>
            <option value="1">SI</option>
            <option value="0">NO</option>
          </select>
        </p>
        <p>
          <strong>VIP?:</strong><br />
          <select className="form-control" name="vip" value={this.state.school.vip} onChange={this.handleInputChange}>
            <option value="1">SI</option>
            <option value="0">NO</option>
          </select>
        </p>
      </div>
    );
  }

  makeDetailsPanel(school) {
    return (
      <div>
        <p>
          <strong>ID/ C.M.:</strong> {school['id']}
        </p>
        <p>
          <strong>Indirizzo:</strong><br />
          {school.address}<br />
          {school.postcode} {school.city_name} {school.province_iso_code ? '(' + school.province_iso_code + ')' : ''}<br />
          {school.country}
        </p>
        <p>
          <strong>Email:</strong> {school['email'] ? <a href={'mailto:' + school['email']}>{school['email']}</a> : 'N/D'}<br />
          <strong>PEC:</strong> {school['certified_email'] ? <a href={'mailto:' + school['certified_email']}>{school['certified_email']}</a> : 'N/D'}<br />
          <strong>Sito web:</strong> {school['website'] ? <a href={school['website']}>{school['website']}</a> : 'N/D'}<br />
        </p>
      </div>
    );
  }

  render() {
    const school = this.state.school;
    if (!school) {
      return '';
    }

    const imgURL = 'https://maps.googleapis.com/maps/api/streetview?parameters&size=640x640&fov=180&location=VIA%20DELLE%20SCUOLE%20RIUNITE%20N.27%2066010%20Roccamontepiano%20Italia&key=AIzaSyAlrO-FS0Hz8unSirhCzBLWfE7oT4CisYE';

    return (
      <div>
        <div className="row">
          <div className="col-7">
            {this.makeDetailsEditorPanel(school)}
          </div>
          <div className="col-5">
            {
              school.parent_school ? (
                <div className="card">
                  <div className="card-header">
                    <h2 style={{fontSize: '1.5rem', color: '#888'}}><i className="fa fa-university" /> Istituto principale</h2>
                  </div>
                  <div className="card-body">
                    <h3>{school.parent_school.name}</h3>
                    <p><strong>Dirigente scolastico:</strong> {'Mario Rossi'}</p>
                    {this.makeDetailsPanel(school.parent_school)}

                    {
                      school.sibling_schools ? (
                        <div>
                        <h2 style={{fontSize: '1.1rem', color: '#888'}}><i className="fa fa-school" /> Plessi</h2>
                        {
                          school.sibling_schools.map((sibling) => {
                            return <div>{sibling}</div>;
                          })
                        }
                        </div>
                      ) : ''
                    }
                  </div>
                </div>
              ) : ''
            }
          </div>
        </div>
        <div className="row">
            <div className="col-12">
              <button className="btn btn-primary" onClick={this.handleSubmit}>Salva modifiche</button>
            </div>
        </div>
      </div>
    );
  }
}

export default SchoolDetailsEditor;


// WEBPACK FOOTER //
// ./src/components/schools/SchoolDetailsEditor.js